import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Paraguay = () => {
    return <SharedDocumentsComponent permissionId="46" path="Paraguai" />
}